import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.for-each.js";
import sharedNode from '@/views/examine/claimRecordManage/components/sharedNode.vue';
import currentNode from '@/views/examine/claimRecordManage/components/currentNode.vue';
import procedure from '@/components/examine/procedure.vue';
import schedule from '@/components/examine/schedule.vue';
import { auditScheduleResource } from '@/views/examine/typeManage/request';
import { auditSchedule, auditDetail, policyDetail } from './request';
import singleLineMultilineModel from '@/views/questionnaire/customerManage/questionnaireList/components/singleLineMultilineModel.vue'; //单行文本and多行文本
import emailSendModel from '@/views/components/emailSend/emailSendModel.vue';
export default {
  components: {
    procedure,
    schedule,
    singleLineMultilineModel,
    emailSendModel,
    sharedNode,
    currentNode
  },
  data() {
    return {
      scheduleList: [],
      procedureList: [],
      step: 0,
      scheduleInfo: {},
      detailsObj: null,
      formData: {},
      rules: {
        d_30803_control_121804: [{
          required: true,
          message: 'Please input Activity name',
          trigger: 'blur'
        }]
      },
      editableArea: [],
      echoNodeIsEdit: null,
      //回显区可编辑状态true可编辑false不可编辑
      editSharedNodeInfo: [],
      //回显区可以编辑的数据
      showSendEmail: false,
      notifyData: null,
      crrentNodeIsEdit: true,
      policyInfo: {}
    };
  },
  created() {
    this.getInfoFun();
    policyDetail({
      policyId: this.$route.params.policyId
    }).then(res => {
      this.policyInfo = res.policyInfo;
      this.policyInfo.customerName = res.baseInfo.customerName;
    });
    this.$store.dispatch('quiretionnaire/getResource');
  },
  methods: {
    async getInfoFun() {
      const res = await auditScheduleResource({
        auditFlowTypeId: this.$route.params.auditFlowTypeId
      });
      if (res.length != 0) {
        this.procedureList = res;
        this.procedureList.unshift({
          iconName: 'container',
          id: -1,
          name: this.$t('报案理赔')
        });
      }
      this.getscheduleFun();
    },
    async getscheduleFun() {
      this.scheduleList = await auditSchedule({
        auditFlowDetailId: this.$route.params.id,
        flowMark: 'claims'
      });
      this.scheduleInfo = this.scheduleList[this.scheduleList.length - 1];
      if (!this.scheduleInfo.currentScheduleOperator && !this.scheduleInfo.operationAt && this.scheduleInfo.step == '0') {
        this.scheduleInfo = this.scheduleList[this.scheduleList.length - 2];
      }
      this.stepFun();
      this.detailFun();
    },
    stepFun() {
      this.step = this.procedureList.findIndex(val => {
        return val.id == this.scheduleInfo.auditFlowScheduleId;
      });
      if (this.step == -1) {
        this.step = 0;
      }
    },
    async detailFun() {
      this.detailsObj = null;
      const res = await auditDetail({
        auditScheduleId: this.scheduleInfo.id,
        flowMark: 'claims'
      });
      console.log(res, 'dkd');
      /**
       * 操作按钮进入$route.params.type == 2可以编辑
       * 查看按钮进入$route.params.type == 1不可以编辑
       */
      this.$route.meta.title = this.$t('理赔详情');
      this.crrentNodeIsEdit = false;
      this.echoNodeIsEdit = false;
      this.detailsObj = res;
    },
    goInfoFun(val) {
      this.scheduleInfo = val;
      this.stepFun();
      this.detailFun();
    },
    // 按钮点击
    onSubmit(buttonItem) {
      if (this.detailsObj.sharedNodeInfo.length > 0) {
        this.$refs.sharedNode.onSubmit();
      }
      if (this.detailsObj.editableAreaInfo.length > 0) {
        this.$refs.currentArea.onSubmit();
      }
      let status = true;
      if (this.detailsObj.sharedNodeInfo.length > 0 && status) {
        status = this.$refs.sharedNode.vidateStatus;
      }
      if (this.detailsObj.editableAreaInfo.length > 0 && status) {
        status = this.$refs.currentArea.vidateStatus;
      }
      if (status) {
        var _this$$refs$currentAr, _this$$refs$sharedNod;
        // 所有校验成功
        // 处理回显节点isEdit:true的情况
        if (this.detailsObj.sharedNodeInfo.length > 0) {
          this.editSharedNodeInfo = JSON.parse(JSON.stringify(this.detailsObj.sharedNodeInfo));
          this.editSharedNodeInfo.forEach((item, index) => {
            if (item.isEdit === false) {
              this.editSharedNodeInfo.splice(index, 1);
            }
          });
        }
        let editSubmitArea = this.$refs.currentArea && (_this$$refs$currentAr = this.$refs.currentArea.submitData) !== null && _this$$refs$currentAr !== void 0 && _this$$refs$currentAr.length ? this.$refs.currentArea.submitData : '';
        let shareSubmitArea = this.$refs.sharedNode && (_this$$refs$sharedNod = this.$refs.sharedNode.submitData) !== null && _this$$refs$sharedNod !== void 0 && _this$$refs$sharedNod.length ? this.$refs.sharedNode.submitData : '';
        //如果按钮有发送邮件的功能 打开发送邮件的弹窗
        if (buttonItem.notify.length > 0) {
          this.notifyData = buttonItem;
          this.showSendEmail = true;
          this.$nextTick(() => {});
        } else {
          let params = {
            auditScheduleId: this.scheduleInfo.id,
            editableArea: JSON.stringify(editSubmitArea),
            sharedNodeInfo: JSON.stringify(shareSubmitArea),
            actionButton: buttonItem
          };
          this.requestSave(params);
        }
      } else {
        this.$message.error(this.$t('请填写完整'));
        return;
      }
    },
    // 提交接口
    // requestSave(params, type) {
    //   auditOperate(params).then(res => {
    //     if (type === 'PREVIEW_FILE') {
    //       this.previewFileList = [];
    //       res.previewFiles?.forEach((item, index) => {
    //         this.previewFileList.push({
    //           name: item.fileName,
    //           url: item.filePath,
    //           uid: index + 1,
    //           status: 'done'
    //         });
    //       });
    //     } else {
    //       this.$message.success('提交成功');
    //       this.$router.push('examine/claimRecordManage');
    //     }
    //   });
    // },
    // 发送邮件回调
    closeModel(notifyData) {
      var _this$$refs$currentAr2, _this$$refs$sharedNod2;
      let editSubmitArea = this.$refs.currentArea && (_this$$refs$currentAr2 = this.$refs.currentArea.submitData) !== null && _this$$refs$currentAr2 !== void 0 && _this$$refs$currentAr2.length ? this.$refs.currentArea.submitData : '';
      let shareSubmitArea = this.$refs.sharedNode && (_this$$refs$sharedNod2 = this.$refs.sharedNode.submitData) !== null && _this$$refs$sharedNod2 !== void 0 && _this$$refs$sharedNod2.length ? this.$refs.sharedNode.submitData : '';
      let params = {
        auditScheduleId: this.scheduleInfo.id,
        editableArea: JSON.stringify(editSubmitArea),
        sharedNodeInfo: JSON.stringify(shareSubmitArea),
        actionButton: notifyData
      };
      this.requestSave(params);
    }
  }
};